import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import LoginPage from 'components/Landing/LoginPage/LoginPage';

import { registerComponents } from '../src/registrations';

registerComponents({ LoginPage });
